var map = {
	"./candidate-start.png": "e03f",
	"./comment-blue.png": "3328",
	"./comment-gxblue.png": "b6dc",
	"./comment-gxgrey.png": "04e3",
	"./comment-red.png": "89a8",
	"./comment-teal.png": "46c0",
	"./comment-white.png": "f2ad",
	"./comment-yellow.png": "d582",
	"./marker-green-32.png": "da08",
	"./marker-green-48.png": "787f",
	"./marker-green.png": "32be",
	"./marker-red-32.png": "0811",
	"./marker-red-48.png": "5a11",
	"./marker-red.png": "2e54"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";